module.exports = __webpack_public_path__ + "static/img/beian_jgwab.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beian_jgwab.png
// module id = wtTz
// module chunks = 1